import { FC, useMemo } from 'react'
import style from './style.m.less'
import { useTranslation } from 'react-i18next'
import { IconButton } from '../../../ui'
import { Email } from '../../../../assets/icons'
import { useNavigate } from 'react-router-dom'

export const Contacts: FC = () => {
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()

    const yandexLang = useMemo(() => {
        const lang = i18n.language.toLowerCase()

        if (lang.includes('ru')) {
            return 'ru_RU'
        } else if (lang.includes('en')) {
            return 'en_US'
        }
        return 'ru_RU'
    }, [i18n.language])

    const mapUrl = `https://yandex.ru/map-widget/v1/?um=constructor%3A736c7e8620775dadfaba7b183bbed1e1955b29b09263f9f3e6d91b8d7b8273b6&amp;source=constructor&amp&lang=${yandexLang}`

    return (
        <div className={style.contacts}>
            <div>
                <h2 className={style.contactsTitle}>{t('documents.contacts')}</h2>
                <p className={style.contactsText}>{t('documents.address')}</p>
                <div className={style.contactsNumbers}>
                    <p className={style.contactsNumber}>+7 (495) 740-30-27</p>
                </div>
                <div className={style.media}>
                    <div>{t('footer.support')}</div>
                    <div>
                        <a href="mailto:help@g-e-t.ru">help@g-e-t.ru</a>
                    </div>
                    <div>{t('footer.application')}</div>
                    <div>
                        <a href="mailto:mail@g-e-t.ru">mail@g-e-t.ru</a>
                    </div>
                </div>
                <div className={style.feedbackBlock}>
                    <p className={style.feedbackText}>{t('feedback.text')}</p>
                    <IconButton icon={<Email />} onClick={() => navigate('/feedback-form')}>
                        {t('feedback.title')}
                    </IconButton>
                </div>
            </div>
            <div>
                <iframe
                    key={yandexLang}
                    src={mapUrl}
                    width="100%"
                    height="100%"
                    style={{
                        minHeight: '400px',
                    }}
                    frameBorder="0"
                    title={''}
                ></iframe>
            </div>
        </div>
    )
}

export default Contacts
